// extracted by mini-css-extract-plugin
export default {"rating":"AT-z","numberOfStars":"BT-z","count":"CT-z","barGraphSpacing":"DT-z","barGraph":"ET-z"};